export default __webpack_public_path__ + "images/PR.e3cf3ac.png";